export default __webpack_public_path__ + "images/moderation-spinner-icon.8c89a4c8b71a8a724aa7fef94e5401ea.gif";